import { put, call } from 'redux-saga/effects';
import { roleCreateAPI, roleSearchAPI, roleUpdateAPI } from 'src/api/RoleApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { ROLE_ACTIONS } from '../actions/RoleActions';
import { toast } from 'react-toastify';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(roleSearchAPI, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
            }),
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: ROLE_ACTIONS.ROLE_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: ROLE_ACTIONS.ROLE_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(roleSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: ROLE_ACTIONS.ROLE_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(roleCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        })); 
        toast("Role Created")
        
        yield put({
            type: ROLE_ACTIONS.ROLE_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
        yield put({
            type: ROLE_ACTIONS.ROLE_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: ROLE_ACTIONS.ROLE_UPSERT_ERROR,
        });
    }
}

function* update(roleId, payload) {
    try {
        yield call(roleUpdateAPI, {
            roleId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if(payload.deleted===true){
            toast("Role deleted")
        }
        else{
            toast("Role updated")
        } 
        
        yield put({
            type: ROLE_ACTIONS.ROLE_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: ROLE_ACTIONS.ROLE_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(ROLE_ACTIONS.ROLE_SEARCH, search),
    takeFirstSagaUtil(ROLE_ACTIONS.ROLE_UPSERT, upsert),
    takeFirstSagaUtil(ROLE_ACTIONS.ROLE_EDIT, edit),
];
